import {
  Directive,
  ElementRef,
  inject,
  output,
} from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
  standalone: true,
  host: {
    '(document:mousedown)': 'onDocumentClick($event)',
  },
})
export class ClickOutsideDirective {
  private el = inject<ElementRef<HTMLElement>>(ElementRef);
  public clickOutside = output<MouseEvent>();

  public onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (!this.el.nativeElement.contains(target)) {
      this.clickOutside.emit(event);
    }
  }
}
